/**
 * PlaneGeometry 사이즈를 viewport사이즈에 맞춤
 * @param fov camera fov(field of view) 수직 시야각
 * @param distanceZ geometry와 카메라의 z축 거리
 * @param aspect width / height 종횡비
 * @returns viewportHeight, viewportWidth (canvas 단위)
 */
export const getViewportCanvas = (
  fov: number,
  distanceZ: number,
  aspect: number = window.innerWidth / window.innerHeight
) => {
  const radian_y = (fov * Math.PI) / 180;
  const viewport_h = distanceZ * Math.tan(radian_y / 2) * 2;

  return {
    viewportHeight: viewport_h,
    viewportWidth: viewport_h * aspect,
  };
};

/**
 * 일반 각도를 라디안 값으로 변환
 * @param degree normal degree
 * @returns radian degree
 */
export const degreeToRadian = (degree: number) => {
  return (Math.PI / 180) * degree;
};

/**
 * Get Image Data
 * 이미지의 각 픽셀 컬러 추출, RGBA[r, g, b, a, ...]
 */
export const getImageData = (image: HTMLImageElement): ImageData => {
  const canvas = document.createElement("canvas");
  canvas.width = image.width;
  canvas.height = image.height;

  const ctx = canvas.getContext("2d")!;
  ctx.drawImage(image, 0, 0);

  return ctx.getImageData(0, 0, image.width, image.height);
};

/**
 * Get Stretch Style
 * 이미지 stretch 그라디언트 추출 (linear-gradient)
 */
export const getStretchStyle = (imageData: ImageData): string => {
  const { data, width } = imageData;
  const rgba = [];

  for (let i = 0; i < data.length; i += 4 * width) {
    rgba.push({ r: data[i], g: data[i + 1], b: data[i + 2] });
  }

  const style = `linear-gradient(${rgba
    .map(({ r, g, b }) => `rgba(${r}, ${g}, ${b}, 255)`)
    .join(", ")})`;

  return style;
};
